export default "__VITE_ASSET__ktD3ppwy__"